import t from '~t'
import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { highlights as getHighlights } from '~data/selectors/bookmarks'
import { toggleHighlights } from '~local/actions'

import { Footer } from '~co/screen/splitview/reader'
import { Button, Icon } from '~ui';

export default function ReaderHighlightsCollapsed({ item: { _id }, tab }) {
    const dispatch = useDispatch()
    const highlights = useSelector(state=>getHighlights(state, _id))
    const onExpandClick = useCallback(()=>dispatch(toggleHighlights()), [])

    return (<Footer data-no-shadow={tab=='edit'}>
        <Button 
            variant='accent'
            onClick={onExpandClick}>
            <Icon name='highlights' />
            {t.format('highlightsCount', highlights.length)}
        </Button>
    </Footer>)
}